const T = require("react").PropTypes;
const Config = require("../../Config.js");

/**
 * Specifies metadata for Marketing URL uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
const MarketingURL = {
    // Factory method
    GetSpecData() {
        const spec = {
            SampleFileURL:  "marketing-target/template",
            IsComplete: true,
            Arg: null
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        SampleFileURL: T.string.isRequired
    })
};

module.exports = MarketingURL;


// WEBPACK FOOTER //
// ./src/types/metadata/MarketingURL.js